export enum OrderOrderBy {
	OrderName = 'OrderName',
	CreateDate = 'CreateDate',
	Origin = 'Origin',
	Items = 'Items',
	Destination = 'Destination',
	Status = 'Status',
	Id = 'Id',
}
